module.exports = __webpack_public_path__ + "img/89.e89d89f2.png";